import { Stack, Text } from '@vtex/admin-ui'
import { useWatch } from '@vtex/admin-ui-form'
import { FieldGroupBox, RuleStack, useFormStateContext } from 'ui'
import {
  RegularBenefit,
  RegularBenefitVariant,
  RegularEffect,
} from '../../../../../../typings'
import { useGenericComponent } from '../../hooks/useGenericComponent'
import { Empty } from './Empty'
import { VIEW_MAP } from './constants'
import { FormattedMessage } from 'react-intl'
import { messages } from './messages'

export type ViewProps = {
  onEdit: (key: RegularBenefitVariant) => void
  onRemove: () => void
  config: RegularBenefit
}

type Props = {
  name: string
  onRemove: () => void
  onEdit: (key: RegularBenefitVariant) => void
}

export function RegularBenefitView(props: Props) {
  const { name, onEdit, onRemove } = props

  const { form } = useFormStateContext()

  const benefit: RegularEffect['benefit'] = useWatch({ name, form })

  const { GenericComponent } = useGenericComponent({
    settings: VIEW_MAP,
    type: benefit?.type,
  })

  return (
    <>
      {benefit ? (
        <Stack space="$space-4" fluid>
          <Text>
            <FormattedMessage {...messages.description} />
          </Text>
          <FieldGroupBox name={name} withBorder={false}>
            <RuleStack>
              <GenericComponent
                config={benefit}
                onRemove={onRemove}
                onEdit={onEdit}
              />
            </RuleStack>
          </FieldGroupBox>
        </Stack>
      ) : (
        <Empty onAdd={onEdit} name={name} />
      )}
    </>
  )
}
